import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from './environment.service';
import { catchError, map, of, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConcurrentUsersService {

  constructor(private http: HttpClient, private env: EnvironmentService) { }

  get(){
    let baseUrl = `${this.env.envVariables.httpProtocol}${this.env.envVariables.webHost}ConcurrentUsers`;
    return this.http.get(baseUrl).pipe(catchError((err) => { return of(err?.error?.actionMessage) }));
  }

  add() {
    let baseUrl = `${this.env.envVariables.httpProtocol}${this.env.envVariables.webHost}ConcurrentUsers/Add`;
    return this.http.get(baseUrl).pipe(map(() => { return true }), catchError((err) => { return of(err?.error?.actionMessage) }));
  }

  remove(user: { id: string, userId: string }, isSignOut: boolean = false) {
    let baseUrl = `${this.env.envVariables.httpProtocol}${this.env.envVariables.webHost}ConcurrentUsers/Remove/${user.userId}`;
    let headers = new HttpHeaders();
    headers = headers.set('Id', user.id);
    headers = headers.set('IsSignOut', isSignOut.toString());
    return this.http.delete(baseUrl, { headers });
  }
}
